import React from 'react';

import './FieldInput.scss';

const FieldInput = props => {

  return (
    <input
      
      type={props.type}
      id={props.id}
      name={props.name}
      placeholder={props.placeholder}
      className={`field__input
      field__${props.size}
      ${props.login && `login__input`}
      ${props.className}
      `}
      value={props.value ? props.value : undefined}
      autoComplete={props.autoComplete}
      onChange={props.inputHandler && props.inputHandler()}
      required={props.required}
      disabled={props.disabled}
    />
  );
};

export default FieldInput;
